export default {"src":"/_next/static/media/ODP.729515aa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};